<mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
<div fxLayout="row" fxFlexFill>
        <mat-form-field style="margin-bottom: 10px" fxFlex="85%" fxFlexOffset="20px">
                <input #nome matInput maxlength="200" name="nome" placeholder="Nome :" [(ngModel)]="projeto.nome"
                        required>
                <mat-hint align="end">{{nome.value.length}} / 200</mat-hint>
        </mat-form-field>

        <mat-checkbox fxFlexOffset="20px" style="padding-top: 24px;" color="primary" name="campoRestricao"
                [(ngModel)]="projeto.restricao">
                Com Restrição
        </mat-checkbox>
        <mat-form-field fxFlex="15%" fxFlexOffset="20px">
        <mat-label>Código Projeto:</mat-label>
                <input [disabled]="false"
                        matInput 
                        maxlength="100" 
                        [(ngModel)]="projeto.codigoProjeto"
                        name="codigoProjeto" 
                        placeholder="Código Projeto">
        </mat-form-field>
</div>

<div ngModelGroup="comboPrograma" fxFlexFill>
     <combo-programa [showDisplayId]="false"
                     [obrigatorio]="false"
                     [selecionado]="projeto.programa"
                     (valorChange)="onValorChangePrograma($event)">
     </combo-programa>
</div>

<div fxLayout="row" fxFlexFill>
        <mat-form-field style="margin-left: 20px" fxFlex="100%" appearance="outline">
                <mat-label>Descrição:</mat-label>
                <textarea matInput #message name="descricao" 
                          [(ngModel)]="projeto.descricao" 
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize" 
                          cdkAutosizeMinRows="3" 
                          maxlength="500">
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 500</mat-hint>
        </mat-form-field>
</div>


<!-- Coordenador -->
<mat-toolbar class="titulopartes">Responsável pelo Projeto</mat-toolbar>
<div fxLayout="row" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
        <mat-form-field style="margin: 0 40px 0 20px" fxFlex="100%">
                <mat-label>Funcionário:</mat-label>
                <mat-select [(ngModel)]="projeto.idCoordenador" name="funcionarios">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let f of funcionarios" [value]="f.id">
                                {{f.nome}}
                        </mat-option>
                </mat-select>
                <mat-hint *ngIf="funcionarios?.length === 0" align="start">Nenhum funcionário cadastrado</mat-hint>
        </mat-form-field>
</div>


<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

        <!--DATAS -->
        <div fxLayout="column" fxFlex="45%">
                <mat-toolbar class="titulopartes">Datas</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                        <mat-form-field fxFlex="50%" fxFlexOffset="20px">
                                <input matInput name="dtImplantacao" 
                                       [matDatepicker]="dataInicio"
                                       placeholder="Data de Início:" 
                                       (input)="onMascaraDataInput($event)"
                                       required
                                       [(ngModel)]="projeto.dataInicio">
                                <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                                <mat-datepicker #dataInicio></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field fxFlex="50%">
                                <input matInput name="dtTermino" 
                                       [matDatepicker]="dataTermino"
                                       placeholder="Data de Fim:" (input)="onMascaraDataInput($event)"
                                       [(ngModel)]="projeto.dataFim">
                                <mat-datepicker-toggle matSuffix [for]="dataTermino"></mat-datepicker-toggle>
                                <mat-datepicker #dataTermino></mat-datepicker>
                        </mat-form-field>

                </div>
        </div>

        <!-- DATAS PREVISTAS -->
        <div fxLayout="column" fxFlex="55%">
                <mat-toolbar class="titulopartes">Datas Previstas</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" style="margin: 0 20px 20px 0" fxFlexFill>

                        <mat-form-field fxFlex="50%" fxFlexOffset="20px">
                                <input matInput name="dtPrevistaImplantacao" [matDatepicker]="dataPrevisaoInicio"
                                        placeholder="Data Prevista de Início:" (input)="onMascaraDataInput($event)"
                                        [(ngModel)]="projeto.dataPrevisaoInicio">
                                <mat-datepicker-toggle matSuffix [for]="dataPrevisaoInicio"></mat-datepicker-toggle>
                                <mat-datepicker #dataPrevisaoInicio></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field fxFlex="50%">
                                <input style="margin-right: 20px" matInput name="dtPrevistaTermino"
                                        [matDatepicker]="dataPrevisaoTermino" placeholder="Data Prevista de Fim:" (input)="onMascaraDataInput($event)"
                                        [(ngModel)]="projeto.dataPrevisaoTermino">
                                <mat-datepicker-toggle matSuffix [for]="dataPrevisaoTermino"></mat-datepicker-toggle>
                                <mat-datepicker #dataPrevisaoTermino></mat-datepicker>
                        </mat-form-field>

                </div>
        </div>
</div>

<mat-toolbar class="titulopartes">Faixa Etária</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin: 0 20px 20px 0" fxFlexFill>
        <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                <input #faixaEtariaInicial matInput type="text" pattern="\d*" maxlength="2" name="faixaEtariaInicial"
                        placeholder="Faixa etária (Inicial)" [(ngModel)]="projeto.faixaEtariaInicial">
                <mat-error>Informa apenas dois valores numéricos</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                <input #faixaEtariaFinal matInput type="text" pattern="\d*" maxlength="2" name="faixaEtariaFinal"
                        placeholder="Faixa etária (Final)" [(ngModel)]="projeto.faixaEtariaFinal">
                <mat-error>Informa apenas dois valores numéricos</mat-error>
        </mat-form-field>
</div>


<mat-toolbar class="titulopartes">Outras informações</mat-toolbar>
<div fxLayout="row" fxFlexFill>
        <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                <mat-label>Público Alvo:</mat-label>
                <textarea #publicoAlvo matInput name="publicoAlvo" [(ngModel)]="projeto.publicoAlvo" cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="8" maxlength="4000"></textarea>
                <mat-hint align="end">{{publicoAlvo.value.length}} / 4000</mat-hint>
        </mat-form-field>

        <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                <mat-label>Justificativa:</mat-label>
                <textarea #justificativa matInput name="justificativa" [(ngModel)]="projeto.justificativa"
                        cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="8"
                        maxlength="4000"></textarea>
                <mat-hint align="end">{{justificativa.value.length}} / 4000</mat-hint>
        </mat-form-field>
</div>

<div fxLayout="row" fxFlexFill>
        <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                <mat-label>Objetivo geral:</mat-label>
                <textarea #objetivoGeral matInput name="objetivoGeral" [(ngModel)]="projeto.objetivoGeral"
                        cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="8"
                        maxlength="2000"></textarea>
                <mat-hint align="end">{{objetivoGeral.value.length}} / 2000</mat-hint>
        </mat-form-field>

        <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                <mat-label>Objetivo especifico:</mat-label>
                <textarea #objetivoEspecifico matInput name="objetivoEspecifico"
                        [(ngModel)]="projeto.objetivoEspecifico" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="8" maxlength="2000"></textarea>
                <mat-hint align="end">{{objetivoEspecifico.value.length}} / 2000</mat-hint>
        </mat-form-field>
</div>